/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { useContext, useEffect, useState } from "react"

import FlexGridOuter from "../../../../components/FlexGridWrapper/FlexGridOuter"
import { TWijmoCellTemplateContext } from "../../../../type/wijmoComponents"

// import pageHelper from "../../../ts/helpers/pageHelper"
import CONSTANT from "../../../../constant"
import { Button } from "react-bootstrap"
import { SearchResultContext } from "./KaikonZyutyuHaisyaPatternModalContext"
// TODO:ダミー
import { TKaikonZyutyuHaisyaPatternListGetRes } from "../../../../service/orderContainer/kaikonZyutyuHaisyaPattern/TKaikonZyutyuHaisyaPattern"

import { T表紙分割 } from "../../../../components/ComboBox/HyosiBunkatuComboBox"

import {
  PICKBindings,
  その他Bindings,
  コンテナ情報Bindings,
  作業Bindings,
  支払Bindings,
  荷主Bindings,
  請求Bindings,
  返却Bindings,
} from "./KaikonZyutyuHaisyaPatternModalConstant"
import { T区分マスタ } from "../../../../components/ComboBox/KubunComboBox"
import { T請求内訳 } from "../../../../components/ComboBox/SeikyuUtiwakeComboBox"
import { 区分分類コード } from "../../../../constant/enum/codes"

import {
  GridInitializedContext,
  IsRestoreSearchingContext,
} from "../../../../components/Context"
import KubunService from "../../../../service/master/kubun/kubunService"
import NinusiSeikyuService from "../../../../service/master/ninusiseikyu/ninusiSeikyuService"

/**
 * 受注配車入力grid部
 * @param props
 * @returns
 */
const KaikonZyutyuHaisyaPatternModalGrid: React.FC<{
  searchConditionClear?: React.MouseEventHandler<HTMLElement>
  gridId: string
  setPattern: (v: TKaikonZyutyuHaisyaPatternListGetRes) => unknown
}> = (props) => {
  //#region [context]

  //grid初期化フラグ
  const { state: gridInitialized, setState: setGridInitialized } = useContext(
    GridInitializedContext
  )
  // gridレストア完了フラグ
  const { state: isRestoreSearching, setState: setIsRestoreSearching } =
    useContext(IsRestoreSearchingContext)

  // 検索結果
  const searchResult = useContext(SearchResultContext)
  //#endregion

  //#region [state]
  //dataMap
  //表紙分割と請求内訳は動的生成
  const [表紙分割DataMap, set表紙分割DataMap] =
    useState<wjcGrid.DataMap<T表紙分割>>()
  const [請求内訳DataMap, set請求内訳DataMap] =
    useState<wjcGrid.DataMap<T請求内訳>>()

  //区分系
  const [コンテナサイズDataMap, setコンテナサイズDataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [コンテナ軸DataMap, setコンテナ軸DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()

  const [課税区分DataMap, set課税区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()

  //#endregion

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TKaikonZyutyuHaisyaPatternListGetRes>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView<TKaikonZyutyuHaisyaPatternListGetRes>(
      data,
      {
        pageSize,
        // GridFooterからのイベント伝達用
        onPageChanged() {
          if (flexGrid && flexGrid.itemsSource) {
            const pageIndex = flexGrid!.itemsSource!.pageIndex
            setPageNumber(pageIndex)
          }
        },
      }
    )
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)

    // handler付与
    grid.formatItem.addHandler(formatItem)
    grid.refresh()
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjcGrid.FlexGrid) => {
    // header行に一行追加
    let extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""
        if (荷主Bindings.includes(c.binding)) {
          setHeaderText = "荷主"
        } else if (コンテナ情報Bindings.includes(c.binding)) {
          setHeaderText = "コンテナ情報"
        } else if (PICKBindings.includes(c.binding)) {
          setHeaderText = "PICK"
        } else if (作業Bindings.includes(c.binding)) {
          setHeaderText = "作業"
        } else if (返却Bindings.includes(c.binding)) {
          setHeaderText = "返却"
        } else if (その他Bindings.includes(c.binding)) {
          setHeaderText = "その他"
        } else if (請求Bindings.includes(c.binding)) {
          setHeaderText = "請求"
        } else if (支払Bindings.includes(c.binding)) {
          setHeaderText = "支払"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        c.align = "left"
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })
  }

  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
  }

  //#endregion

  //#region [baseState]

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  //アラート制御
  //   const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [effect]

  //初期表示
  useEffect(() => {
    //区分値の確保
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      setコンテナサイズDataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード === 区分分類コード.受注配車_請求支払.コンテナサイズ
          ),
          "区分コード",
          "名称1"
        )
      )
      setコンテナ軸DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.コンテナ軸
          ),
          "区分コード",
          "名称1"
        )
      )
      set課税区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分
          ),
          "区分コード",
          "名称1"
        )
      )
    })
  }, [])

  // 初回表紙分割、請求内訳取得用メソッド
  //TODO
  const 初回荷主請求取得 = async (検索条件: any[]) => {
    const 荷主IdList = 検索条件
      .filter((a) => a.荷主ID != null)
      .map((a) => a.荷主ID as number)
    const 荷主請求IdList = 検索条件
      .filter((a) => a.荷主請求ID != null)
      .map((a) => a.荷主請求ID as number)

    try {
      const res = await new NinusiSeikyuService().getList({
        荷主IdList,
      })

      if (res && res.data) {
        //TODO:実際はAPIより取得
        set表紙分割DataMap(
          new wjcGrid.DataMap([...res.data], "荷主請求ID", "表紙名")
        )
      }
      const 内訳Res = await new NinusiSeikyuService().getListUchiwake({
        荷主請求IdList,
      })
      if (内訳Res && 内訳Res.data) {
        set請求内訳DataMap(
          new wjcGrid.DataMap(内訳Res.data, "荷主請求内訳ID", "請求内訳名")
        )
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (searchResult == null) return
    // 取得したデータより表紙分割と請求内訳を取得
    初回荷主請求取得(searchResult)
    setGridData({ data: createCollectionView(searchResult, pageSize) })

    flexGrid?.refresh()
  }, [searchResult])

  //#endregion

  return (
    <>
      <FlexGridOuter
        flexGrid={flexGrid}
        setFlexGrid={setFlexGrid}
        gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
        gridData={gridData}
        setGridData={setGridData}
        pageNumber={pageNumber}
        searchConditionClear={props.searchConditionClear}
        gridId={props.gridId}
        isRestoreSearching={isRestoreSearching}
        isEnablePageSize={"visible"}
        isEnableExport={false}
        setIsRestoreSearching={setIsRestoreSearching}
        gridInitialized={gridInitialized}
        setGridInitialized={setGridInitialized}
        pageSize={pageSize}
        setPageSize={setPageSize}
        gridInitializedHandler={gridInitializedHandler}
        gridProperties={{
          frozenColumns: 5,
          allowMerging: wjcGrid.AllowMerging.ColumnHeaders,
          headersVisibility: wjcGrid.HeadersVisibility.Column,
          keyActionTab: wjcGrid.KeyAction.CycleOut,
        }}>
        <wjrGrid.FlexGridColumn
          header="選択"
          allowDragging={false}
          hasFilter={false}
          allowSorting={false}
          binding="受注配車id"
          allowMerging={true}
          align="center"
          width={100}
          selectable={false}
          isReadOnly>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaPatternListGetRes>
            ) => {
              return (
                <Button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault()
                    props.setPattern(context.item)
                  }}>
                  選択
                </Button>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        {/* パターン検索 */}
        <wjrGrid.FlexGridColumn
          binding="受注配車パターンコード"
          width={128}
          header="パターンCD"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="受注配車パターン名"
          width={200}
          header="パターン名"></wjrGrid.FlexGridColumn>
        {/* 荷主 */}
        <wjrGrid.FlexGridColumn
          binding="荷主コード"
          width={80}
          header="荷主CD"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主略称1"
          width={128}
          isReadOnly
          header="荷主名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主請求ID"
          width={128}
          dataMap={表紙分割DataMap}
          header="表紙名"></wjrGrid.FlexGridColumn>
        {/* コンテナ情報 */}
        <wjrGrid.FlexGridColumn
          binding="コンテナサイズ名称1"
          width={128}
          dataMap={コンテナサイズDataMap}
          header="コンテナサイズ"></wjrGrid.FlexGridColumn>
        {/* 積卸時間 */}
        <wjrGrid.FlexGridColumn
          binding="コンテナ軸名称1"
          width={128}
          dataMap={コンテナ軸DataMap}
          header="コンテナ軸"></wjrGrid.FlexGridColumn>
        {/* PICK */}
        <wjrGrid.FlexGridColumn
          binding="PICK積卸先名称"
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK積卸先市区町村"
          header="市区町村"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK運行部所コード"
          header="運行部所"></wjrGrid.FlexGridColumn>
        {/* 作業 */}
        <wjrGrid.FlexGridColumn
          binding="作業積卸先名称"
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業積卸先市区町村"
          header="市区町村"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="作業運行部所コード"
          header="運行部所"></wjrGrid.FlexGridColumn>
        {/* 返却 */}
        <wjrGrid.FlexGridColumn
          binding="返却積卸先名称"
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却積卸先市区町村"
          header="市区町村"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却運行部所コード"
          header="運行部所"></wjrGrid.FlexGridColumn>
        {/* その他 */}
        <wjrGrid.FlexGridColumn
          binding="その他積卸先名称"
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他積卸先市区町村"
          header="市区町村"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他運行部所コード"
          header="運行部所"></wjrGrid.FlexGridColumn>
        {/* 請求 */}
        <wjrGrid.FlexGridColumn
          binding="荷主請求内訳ID"
          dataMap={請求内訳DataMap}
          header="請求内訳"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求運送料課税区分コード"
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求運送料"
          cssClass="number-col"
          header="運送料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求付帯料課税区分コード"
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求付帯料"
          cssClass="number-col"
          header="付帯料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求高速料税込区分名称"
          isReadOnly={true}
          header="込/抜"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求高速料"
          cssClass="number-col"
          header="高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求合計"
          cssClass="number-col"
          isReadOnly={true}
          header="請求合計"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="計上基準日区分名称"
          isReadOnly={true}
          header="請求基準日"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求備考"
          header="請求備考"></wjrGrid.FlexGridColumn>
        {/* 支払 */}
        <wjrGrid.FlexGridColumn
          binding="支払運送料課税区分コード"
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払運送料"
          cssClass="number-col"
          header="運送料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払付帯料課税区分コード"
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払付帯料"
          cssClass="number-col"
          header="付帯料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払高速料税込区分名称"
          header="込/抜"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払高速料"
          cssClass="number-col"
          header="高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払合計"
          cssClass="number-col"
          header="支払合計"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払備考"
          header="支払備考"></wjrGrid.FlexGridColumn>
      </FlexGridOuter>
    </>
  )
}

export default KaikonZyutyuHaisyaPatternModalGrid
